import React from 'react';
import { observer } from 'mobx-react';
// import { toJS } from 'mobx';
import { NavLink } from 'react-router-dom';
// import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from 'reactstrap';
import { slide as Menu } from 'react-burger-menu';
import classNames from 'classnames';

import btPlusLogo from '../../../assets/images/boardtrac_plus_logo.svg';
import btPlusMobileLogo from '../../../assets/images/btp-mobile-logo.svg';
import dashboardIcon from '../../../assets/images/dashboard_top_navbar_icon.svg';
// import searchIcon from '../../../assets/images/search_top_navbar_icon.svg';
import warIcon from '../../../assets/images/worth_a_read_top_navbar_icon.svg';
import refreshIcon from '../../../assets/images/refresh_top_navbar_icon.svg';
import offlineIcon from '../../../assets/images/wifi-offline.svg';
import ProfileMenu from './ProfileMenu';
import { anyWarNew } from '../../../helpers/localStorage';

import store from '../../../stores/store';
import BTMenu from './BTMenu';
import './AppMenu.css';
import { showScroll, hideScroll } from '../../../helpers/utils';
import {
    REFRESH_BTN_OFFLINE_MSG,
    FETCH_ERROR_TITLE,
    FETCH_ERROR_MSG,
} from '../../../helpers/messageText';

const AppMenu = observer(
    class AppMenu extends React.Component {
        constructor(props) {
            super(props);

            this.toggle = this.toggle.bind(this);
            this.close = this.close.bind(this);
            this.handleClickOutsideDropDownMenu = this.handleClickOutsideDropDownMenu.bind(this);

            this.state = {
                isOpen: false,
                showHamburgerIcon: false,
                showHamburgerMenu: false,
                show: {},
            };
        }

        componentWillMount() {
            store.user.initilizeUserProfile();
            store.user.fetch();
        }

        onResize = v => {
            // console.log('AppMenu onResize', v);
            if (this.state.showHamburgerIcon === v) return;
            this.setState({
                showHamburgerIcon: v,
            });
        };

        componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutsideDropDownMenu, true);
        }

        reloadContent = async () => {
            //first need to ensure will display the correct tab after refresh
            //this applies to the content menu sub item routing ONLY
            if (this.props.location.pathname.indexOf('dashboard') !== -1) {
                store.companies.routeBeforeRefresh = this.props.location.pathname;
            }

            store.meetings.set("loading", true);
            store.votes.set("loading", true);
            store.tasks.set("loading", true);
            store.companies.set("loadingGovernance", true);

            store.companies.fetch().then(resp => {
                store.user.fetch();
            }).catch(error => {
                this.triggerBadConnAlert();
            });
        };

        triggerBadConnAlert = () => {
            store.alert.setAlert(
                store.alert.hideAlert,
                '',
                FETCH_ERROR_TITLE,
                FETCH_ERROR_MSG,
                'OK',
                '',
            );
        };

        reloadWarContent = () => {
            store.war.fetch();
        };

        toggle() {
            if (!this.state.isOpen) {
                document.addEventListener('click', this.handleClickOutsideDropDownMenu, true);
            } else {
                document.removeEventListener('click', this.handleClickOutsideDropDownMenu, true);
            }

            this.setState({
                isOpen: !this.state.isOpen,
            });
        }

        close() {
            if (this.state.isOpen) {
                this.toggle();
            }
        }

        handleClickOutsideDropDownMenu(e) {
            const container = this._menuWrapper;
            if (e.target !== container && !container.contains(e.target)) {
                this.toggle();
            }
        }

        onStateChanged = state => {
            state.isOpen ? hideScroll() : showScroll();
        };

        onChangeVisibility = status => {
            // console.log('AppMenu onChangeVisibility', status);
            this.setState({ show: Object.assign(this.state.show, status) });
        };

        buildRefreshButton = () => {
            return (
                <div>
                    <BTMenu.Item id="1" onChangeVisibility={this.onChangeVisibility} className={store.conn.isOnline ? '' : 'hide-refresh'}>
                        {/* {this.buildRefreshButton(store.conn.isOnline)} */}
                        <a className="btp-menu-item" onClick={this.reloadContent}>
                            <img src={refreshIcon} alt="Refresh" />
                            <br />Refresh
                        </a>
                    </BTMenu.Item>
                    <BTMenu.Item id="1" onChangeVisibility={this.onChangeVisibility} className={store.conn.isOnline ? 'hide-refresh' : ''}>
                        <a className="btp-menu-item disabled" onClick={store.conn.checkOnlineStatus} title={REFRESH_BTN_OFFLINE_MSG}>
                            <img src={offlineIcon} alt="Offline" />
                            <br />Offline
                        </a>
                    </BTMenu.Item>
                </div>)
        }

        buildHamburgerRefreshButton = () => {
                return (
                    <div>
                    <a className={store.conn.isOnline ? 'btp-menu-item' : 'btp-menu-item hide-refresh'} onClick={this.reloadContent}>
                        <img src={refreshIcon} alt="Refresh" />
                        <br />Refresh
                    </a><a className={store.conn.isOnline ? 'btp-menu-item disabled hide-refresh' : 'btp-menu-item disabled'} onClick={store.conn.checkOnlineStatus} title={REFRESH_BTN_OFFLINE_MSG} >
                        <img src={offlineIcon} alt="Offline" />
                        <br />Offline
                    </a>
                    </div>
                )
        }

        render() {
            let shouldDisplayWarBadge = false;
            if (!store.war.loading) {
                shouldDisplayWarBadge = anyWarNew();
            }

            return (
                <div className="navbar sticky-top">
                    <nav className="top-menu-panel top-navbar-decoration d-flex justify-content-between">
                        <NavLink className="logo" to="/dashboard">
                            <img
                                src={btPlusLogo}
                                alt="Boardtrac"
                                className="desktop img-fluid"
                            />
                            <img
                                src={btPlusMobileLogo}
                                alt="Boardtrac"
                                className="mobile img-fluid"
                            />
                        </NavLink>

                        <div className="d-flex flex-row" id="topnav-menu">
                            <BTMenu onResize={this.onResize}>
                                <li className="btp-menu-item">
                                    <NavLink
                                        to="/dashboard"
                                        className="btp-menu-item"
                                        activeClassName="selected"
                                    >
                                        <img src={dashboardIcon} alt="Dashboard" />
                                        <br />Dashboard
                                    </NavLink>
                                </li>

                                {this.buildRefreshButton()}

                                <BTMenu.Item id="3" onChangeVisibility={this.onChangeVisibility}>
                                    <NavLink
                                        to="/wortharead"
                                        exact
                                        className="btp-menu-item"
                                        activeClassName="selected"
                                    >
                                        <div onClick={this.reloadWarContent}>
                                            <img src={warIcon} alt="Info Hub" />
                                            {shouldDisplayWarBadge ? (
                                                <span className="badge badge-pill badge-notify animated swing">
                                                    New
                                                </span>
                                            ) : null}
                                            <br />Info Hub{' '}
                                        </div>
                                    </NavLink>
                                </BTMenu.Item>
                            </BTMenu>
                            <div
                                className={classNames('btp-menu-username', {
                                    ['vertical-ellipse']: this.state.showHamburgerIcon,
                                })}
                            >
                                <ProfileMenu history={this.props.history} />
                            </div>
                            {this.state.showHamburgerIcon && (
                                <Menu
                                    outerContainerId={'main'}
                                    onStateChange={this.onStateChanged}
                                    isOpen={this.state.showHamburgerMenu}
                                    right
                                    width={280}
                                    burgerButtonClassName={'app-menu-burger-button'}
                                    crossButtonClassName={'app-menu-close-button'}
                                    menuClassName={'app-menu-vertical'}
                                    itemListClassName={'app-menu-vertical-list'}
                                    crossClassName={'app-menu-close-button-cross'}
                                >
                                    {!this.state.show['1'] && (
                                        <li
                                            className="btp-menu-item"
                                            onClick={() => {
                                                this.setState({ showHamburgerMenu: false });
                                            }}
                                        >{this.buildHamburgerRefreshButton()}</li>
                                    )}
                                    {!this.state.show['3'] && (
                                        <li className="btp-menu-item">
                                            <NavLink to="/wortharead" activeClassName="selected">
                                                <img src={warIcon} alt="Info Hub" />
                                                {shouldDisplayWarBadge ? (
                                                    <span className="badge badge-pill badge-notify animated swing">
                                                        new
                                                    </span>
                                                ) : null}
                                                <br />Info Hub
                                            </NavLink>
                                        </li>
                                    )}
                                </Menu>
                            )}
                        </div>
                    </nav>
                </div>
            );
        }
    },
);

export default AppMenu;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/AppMenu/AppMenu.js